var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindow = function SvgWindow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29692 5.60805C8.51343 5.77945 8.55001 6.09391 8.37861 6.31042L6.62305 8.52808C6.45165 8.74459 6.13719 8.78116 5.92068 8.60977C5.70416 8.43837 5.66759 8.12391 5.83899 7.90739L7.59455 5.68974C7.76595 5.47322 8.08041 5.43665 8.29692 5.60805Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2869 5.60981C10.5034 5.78121 10.54 6.09567 10.3686 6.31218L7.29634 10.1931C7.12494 10.4096 6.81048 10.4462 6.59396 10.2748C6.37745 10.1034 6.34088 9.78891 6.51228 9.5724L9.58451 5.6915C9.7559 5.47499 10.0704 5.43841 10.2869 5.60981Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3786 15.8092C16.55 15.5927 16.5134 15.2782 16.2969 15.1068C16.0804 14.9354 15.7659 14.972 15.5946 15.1885L13.839 17.4062C13.6676 17.6227 13.7042 17.9371 13.9207 18.1085C14.1372 18.2799 14.4517 18.2434 14.623 18.0269L16.3786 15.8092Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4233 16.0761C18.5947 15.8596 18.5581 15.5451 18.3416 15.3737C18.1251 15.2023 17.8106 15.2389 17.6392 15.4554L14.567 19.3363C14.3956 19.5528 14.4321 19.8673 14.6487 20.0387C14.8652 20.2101 15.1796 20.1735 15.351 19.957L18.4233 16.0761Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 23C2.44772 23 2 22.5523 2 22C2 21.4477 2.44772 21 3 21V10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10V21C21.5523 21 22 21.4477 22 22C22 22.5523 21.5523 23 21 23H3ZM13 3.07089V12H19V10C19 6.47353 16.3923 3.55612 13 3.07089ZM11 12V3.07089C7.60771 3.55612 5 6.47353 5 10V12H11ZM11 14V21H5V14H11ZM13 21V14H19V21H13Z",
    fill: "currentColor"
  })));
};
export default SvgWindow;